/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Box } from "@mui/material";
import EmptyFileIcon from "../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import SearchIconWithPeople from "../../../assets/svg/SearchIconWithPeople";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
// import ExportButton from "../../../components/common/ExportButton/ExportButton";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../contants";
// import { MEMBER_SEARCH_COL } from "../../../contants/table/memberSearch";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  INITIATE_GOHONZON_TRACKING,
  SET_MEMBER_FOR_TRACKING_GOHONZON,
  SET_SELECTED_MEMBER_TRANSFER,
} from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import OrganizationSearchWrapper from "../../member/MemberSearch/OrganizationSearch";
import {
  getFilters,
  getFormattedQuery,
  handleDependencyFilter,
  performOperation,
} from "../../appointment/AppointmentTracking/Utils";
import Styles from "../../member/MemberSearch/MemberSearch.styles";
import Popover from "../../member/MemberSearch/Popover/Popover";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import GOhonzonTrackingTable from "./Table";
import Gohonzon from "../../../services/api/gohonzon";
import Button from "../../../components/common/Button";
// import MemberTable from "./MemberTable/MemberTable";

// import {
//   getFilters,
//   getFormattedQuery,
//   getRoutePath,
//   handleDependencyFilter,
//   performOperation,
// } from "./utils";

const LOADER_DELAY = 1000;
const PAGE = "page";
const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
];

const FILTER_KEYS = {
  ADVANCE_FILTER: "advance-filter",
  PERSONAL_FILTER: "personal-filter",
  ORGANISATION_STRUCTURE_FILTER: "orgainsation-structure-filter",
};

const SEARCH_FILTERS = [
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearchWrapper,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
  {
    key: FILTER_KEYS.PERSONAL_FILTER,
    component: PersonalDetailsSearch,
    popOverprops: {
      heading: "Advance Search",
      minHeight: 200,
    },
  },
];

function GohonzonTracking() {
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const {
    isHelpDesk,
    isChapterSi,
    isHelpDeskAdmin,
    isAreaSi,
    isClusterSi,
    isZoneSi,
  } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [openHDCModal, setOpenHDCModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);

  const toast = useContext(ToastAlertContext);

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    // setPaginationInfo(intialPaginationState);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const getRoutePath = () => ROUTES.GOHONZON_TRACKING.path;

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      number: 0,
      size: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    // handle dependency filter
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    // setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
    if (
      ((!formattedQuery.hasOwnProperty("applicationFrom") ||
        formattedQuery.dateFrom === "") &&
        !formattedQuery.hasOwnProperty("applicationTo")) ||
      formattedQuery.dateTo === ""
    ) {
      toast.show("Please enter date from Advance Search", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (queryParams) => {
    const formattedQuery = getFormattedQuery({
      ...queryParams,
      page: queryParams.number,
      size: queryParams.size,
    });

    dispatch({
      type: INITIATE_GOHONZON_TRACKING,
      payload: formattedQuery,
    });

    try {
      setIsLoading(true);

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const { data } = await Gohonzon.gohonzonTracking(formattedQuery);
        // Showing some delay to avoid loader flicker issue
        setTimeout(() => {
          setSearchData(data.content);
          setCurrentPage(data.number);
          setTotalPages(data.totalPages);
          setTotalElements(data.totalElements);
          setPageSize(pageSize);
          setIsLoading(false);
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // Extract form values using formRef
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);
    formData.number = 0;
    formData.size = Constants.DEFAULT_PAGE_SIZE;
    const query = queryString.stringify(formData);

    // Close all popover
    document.dispatchEvent(new Event(EVENT_NAME));
    updateSearchParam(query); // it will trigger below useEffect
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params);
      initializeFormState(query);
    } else {
      resetFormState();
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      delete query.number;
      delete query.size;
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    }
  }, [metaData, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      number: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      number: 0,
      size: queryObject.pageSize
        ? performOperation(
            queryObject.size,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };
  // };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onMemberSelect = (selectedMember, params = "") => {
    dispatch({
      type: SET_MEMBER_FOR_TRACKING_GOHONZON,
      payload: selectedMember,
    });
    navigate(`/${ROUTES.GOHOZON_SUBMISSION.path}${params ? `/${params}` : ""}`);
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const clearAllFilter = () => {
    updateSearchParam();
  };
  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  const closeRoleModal = () => {
    setOpenRoleModal(false);
  };

  const closeHDCModal = () => {
    setOpenHDCModal(false);
  };

  // useEffect(
  //   (queryParams) => {
  //     fetchSearchData({ ...queryParams, number: currentPage, size: pageSize });
  //   },
  //   [currentPage, pageSize]
  // );

  return (
    <div style={Styles.container}>
      <div style={Styles.filter}>
        <form style={Styles.left} onSubmit={onSubmit} ref={formRef}>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
            }}
          >
            {SEARCH_FILTERS.map(
              ({ component: Component, popOverprops, key }) => (
                <Popover key={key} {...popOverprops}>
                  <Component
                    formRef={formRef}
                    disabledOSKeys={disabledOSKeys}
                  />
                </Popover>
              )
            )}

            <Button label="Search" type="submit" />
          </Box>
        </form>
        <div style={Styles.right}>
          {/* <ExportButton
            data={searchData}
            columnHeadingList={MEMBER_SEARCH_COL}
            fileName="member_search"
          /> */}
          {searchData?.length ? (
            <div style={Styles.totalElements}>
              Total Members: {totalElements}
            </div>
          ) : null}
          <div style={Styles.reload} onClick={onRefresh}>
            <ReloadIcon />
          </div>
        </div>
      </div>
      <div style={Styles.main}>
        {/* {searchData?.length ? (
          <div style={Styles.totalElements}>
            Total Members: {paginationInfo.totalElements}
          </div>
        ) : null} */}
        {appliedFilters.length ? (
          <div style={Styles.filterWrapper}>
            <div style={Styles.filterContainer}>
              {/* {appliedFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))} */}
              {orderedFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))}
              {additionalFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))}
            </div>
            <div style={Styles.clearAll} onClick={clearAllFilter}>
              Clear
            </div>
          </div>
        ) : null}
        {searchData?.length ? (
          <>
            <GOhonzonTrackingTable
              searchData={searchData}
              onSelectMemberForTransfer={onSelectMemberForTransfer}
              onMemberSelect={onMemberSelect}
              hasPermission={hasPermission}
              showStatusColumn={isHelpDesk || isHelpDeskAdmin}
              isChapterSi={isChapterSi}
              isHelpDesk={isHelpDesk}
              isAreaSi={isAreaSi}
              isClusterSi={isClusterSi}
              isZoneSi={isZoneSi}
              isHelpDeskAdmin={isHelpDeskAdmin}
            />
            <div style={Styles.pagination}>
              {/* <div style={Styles.totalSize}>
                Number of Members found: {paginationInfo.totalResults}
              </div> */}
              <Pagination
                totalPages={totalPages}
                totalResults={totalElements}
                currentPage={currentPage}
                pageSize={pageSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </div>
          </>
        ) : (
          <div style={Styles.initialContent}>
            {appliedFilters.length ? (
              <>
                <EmptyFileIcon width={100} />
                <span style={Styles.text}>
                  No data found with current Filters
                </span>
              </>
            ) : (
              <>
                <SearchIconWithPeople width={100} />
                <span style={Styles.text}>Choose your Search Filter</span>
              </>
            )}
          </div>
        )}
      </div>
      {isLoading && <Loader />}
      <Modal
        open={openRoleModal}
        onClose={closeRoleModal}
        title="Roles"
        customStyle={{ minWidth: "30%" }}
      />
      <Modal
        open={openHDCModal}
        onClose={closeHDCModal}
        title="Honorary District Chief"
        // customStyle={{ width: "80%" }}
      />
    </div>
  );
}

export default GohonzonTracking;
